@if (requiresValue) {
  <app-inputs Label="" [formControl]="inputCtrl" [type]="'text'"></app-inputs>
}
